import { createFileRoute } from '@tanstack/react-router'
import { EditOrgDialogPending } from '@/routes/_app/-components/shared/dialog-pending'
import { useModalSlot } from '@/components/custom/modal-slot'
import EditOrgDialog from '@/routes/_app/-dialogs/edit-org'

export const Route = createFileRoute('/@modal/orgs/$orgId/edit')({
  staticData: { slotScope: '/_app/orgs' },
  pendingComponent: EditOrgDialogPending,
  component: EditOrgSlot,
})

function EditOrgSlot() {
  const { params, ...slot } = useModalSlot(Route)
  return <EditOrgDialog orgId={params.orgId} {...slot} />
}
